import { formatUserNameWithPhone } from "shared/util/format-phone-for-display";

export function GetParentOptionsFromStudent(userMap, studentToParentMap, studentId) {
  const parentIds = studentToParentMap[studentId?.toString()];
  if (parentIds?.length) {
    return parentIds
      .map((parentId) => {
        const user = userMap[parentId];
        if (user) {
          return {
            label: user.name,
            value: user.id.toString(),
          };
        }
        return null;
      })
      .filter(Boolean);
  }
  return null;
}

export function GetParentNamesWithPhoneNumberFromStudent(userMap, studentToParentMap, studentId) {
  const parentIds = studentToParentMap[studentId?.toString()];
  if (parentIds?.length) {
    return parentIds
      .map((parentId) => {
        const user = userMap[parentId];
        if (user) {
          return formatUserNameWithPhone(user);
        }
        return null;
      })
      .filter(Boolean);
  }
  return null;
}
